import React, { Fragment } from 'react';
import { Container, Row } from 'reactstrap';
import { Breadcrumbs } from '../../AbstractElements';
import TestSeriesTable from './TestSeriesTable';
const Testseries = () => {
  return (
    <Fragment>
      <Breadcrumbs mainTitle='Course' parent='Exam'  />
      <Container fluid={true}>
        <Row>
          <TestSeriesTable />
        </Row>
      </Container>
    </Fragment>
  );
};

export default Testseries;
